import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
import { getCountry, isValidPhoneNumber } from '@fxtr/i18n';

export function trimPhoneInput(value = '') {
  return `${value}`.trim();
}

export function getDefaultPhoneCountry(segment) {
  if (!segment) {
    return undefined;
  }

  return getCountry(segment);
}

function formatPhoneNumberE164(value, segment) {
  const country = getDefaultPhoneCountry(segment);
  const phoneNumber = parsePhoneNumberFromString(value, country);

  return phoneNumber?.format('E.164');
}

export function validatePhoneNumber(value, segment, options = {}) {
  const { mobileOnly = false } = options;
  const trimmed = trimPhoneInput(value);

  if (!trimmed) {
    return { valid: true };
  }

  if (!segment) {
    return {
      valid: false,
      message: mobileOnly ? 'invalidMobileNumber' : 'invalidPhoneNumber',
    };
  }

  const numberType = mobileOnly ? 'MOBILE' : undefined;

  if (!isValidPhoneNumber(trimmed, segment, numberType)) {
    return {
      valid: false,
      message: mobileOnly ? 'invalidMobileNumber' : 'invalidPhoneNumber',
    };
  }

  return {
    valid: true,
    normalized: formatPhoneNumberE164(trimmed, segment),
  };
}

export function normalizePhoneNumber(value, segment, options = {}) {
  const result = validatePhoneNumber(value, segment, options);

  if (!result.valid) {
    return trimPhoneInput(value);
  }

  if (!trimPhoneInput(value)) {
    return '';
  }

  return result.normalized || trimPhoneInput(value);
}
